export const endpoints = {
  list: () => `/commons/cities/`,
};
